module.exports = __webpack_public_path__ + "img/00050.54f0702f.webp";